import './_product-upsell.scss';
import {addPaginationButtons} from 'snippets/pagniation-buttons/pagination-buttons';
import {updateCart} from 'sections/sidebar-cart/sidebar-cart';
import {triggerOpenSidebarCart} from 'snippets/cart-js/ajax-add-cart';

const PRODUCT_UPSELLS_SELECTOR = '.product-upsells';

window.addEventListener('resize', () => {
    document.querySelectorAll(PRODUCT_UPSELLS_SELECTOR).forEach((el) => {
        el.updatePaginationButtons();
    });
});

class ProductUpsell extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.updatePaginationButtons();
        this.querySelectorAll('button').forEach((button) => {
            button.addEventListener('click', this.onAddToCart.bind(this));
        });
    }

    updatePaginationButtons() {
        const config = {
            paginationContainer: '.upsell-pagination-container',
            scrollSection: '.product-upsells-inner',
            pageSection: `${PRODUCT_UPSELLS_SELECTOR}#${this.id}`,
            productCard: '.upsell-card',
            productCardPadding: 16,
            scrollSectionPadding: 48
        };
        addPaginationButtons(config);
    }

    async onAddToCart(e) {
        e.preventDefault();
        const target = e.target;
        const cartTotal = document.querySelector('.sidebar-cart-total');
        if(cartTotal) {
            cartTotal.classList.add('loading');
        }
        this.classList.add('button--disabled');
        const rootItem = target.closest('.upsell-card');
        const itemId = rootItem.getAttribute('data-line-item-id');
        await fetch(window.localeUrl + '/cart/add.js', {
            method: 'post',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ items: [{ id: itemId, quantity: 1 }] }),
        }).then(() => {
            updateCart();
            const productUpsellCard = this.querySelector(`.upsell-card[data-line-item-id='${itemId}']`);
            if(productUpsellCard) {
                productUpsellCard.remove();
                const innerContainer = this.querySelector('.product-upsells-inner');
                if (innerContainer && innerContainer.childElementCount === 0) {
                    this.parentElement.querySelector('.upsell-title')?.remove();
                    this.remove();
                }
            }
            if(this.id !== 'sidebar-cart-upsell') {
                triggerOpenSidebarCart();
            }
            this.updatePaginationButtons();
        });
    }
}

customElements.define('product-upsell', ProductUpsell);
